import { memo } from "react";

function MissedPickupMarker(props) {
  const { backgroundColor, borderColor, size = 27 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9982_47030)">
        <path
          d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
          fill={backgroundColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.675 5C5.30221 5 5 5.30221 5 5.675V18.675C5 19.0478 5.30221 19.35 5.675 19.35H10.175V18H6.35V6.35H17.5V12.175H18.85V5.675C18.85 5.30221 18.5478 5 18.175 5H5.675ZM13.6465 14.675C13.6465 14.3022 13.9487 14 14.3215 14H17.8215C18.1943 14 18.4965 14.3022 18.4965 14.675V18.175C18.4965 18.5478 18.1943 18.85 17.8215 18.85C17.4487 18.85 17.1465 18.5478 17.1465 18.175V16.3046L14.1523 19.2988C13.8887 19.5624 13.4613 19.5624 13.1977 19.2988L9.1977 15.2988C8.9341 15.0352 8.9341 14.6078 9.1977 14.3442C9.46131 14.0806 9.88869 14.0806 10.1523 14.3442L13.675 17.8669L16.1919 15.35H14.3215C13.9487 15.35 13.6465 15.0478 13.6465 14.675Z"
          fill={borderColor}
        />
        <path
          d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
          stroke={borderColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_9982_47030">
          <rect width="24" height="24" fill={borderColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(MissedPickupMarker);
